import hospitalService from "../services/hospital.service";
import sessionHelper from "./session.helper";

// VAPT Fix W2 retest: decode JWT payload so we can restore the real
// email_id / registration_id that the API now masks in the response body.
function decodeJwt(token) {
  try {
    if (!token || typeof token !== "string") return null;
    const parts = token.split(".");
    if (parts.length !== 3) return null;
    // base64url -> base64
    let payload = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    while (payload.length % 4) payload += "=";
    return JSON.parse(atob(payload));
  } catch (e) {
    return null;
  }
}

class CommonHelper {
  fetchHospital = async (vm) => {
    try {
      vm.hospitals = [];
      let { user_type, hospital_id } = vm.$store.getters.user;
      let doc = { user_type };
      if (user_type == 1) {
        doc.hospital_id = hospital_id;
        vm.form.hospital_id = hospital_id.toString();
        vm.submit();
        return;
      }
      vm.$loader.show();
      let { data } = await hospitalService.list(doc);
      let { status, msg, list } = data;
      if (!status) {
        vm.$loader.hide();
        vm.$alert.show(msg);
        return;
      }
      vm.$loader.hide();
      vm.hospitals = list.map((item) => {
        item.name = item.hospital_name;
        item.value = item.hospital_id;
        return item;
      });
      vm.$emit("hospitals", vm.hospitals);
    } catch (error) {
      console.log(error.message);
      vm.$loader.hide();
      vm.$alert.show(error.message);
    }
  };
  setAuth(vm, data, isMain) {
    let { login_details, contact_organ_mapping, user_rights } = data;
    // VAPT Fix W1 retest: JwtToken is no longer in the response BODY.
    // The axios response interceptor read the `X-Auth-Token` response header
    // and saved it to localStorage.token. Read it back here so we can decode
    // the claims and populate sessionStorage with the real email/reg_id.
    // Fallback to data.JwtToken just in case older API version is in flight.
    const JwtToken = localStorage.token || data.JwtToken || "";
    if (data.JwtToken) localStorage.token = data.JwtToken; // legacy path

    // VAPT Fix W6: replaced document.cookie-based `session` / `session_details`
    // (JS cookies cannot be HttpOnly) with sessionStorage. The HttpOnly+Secure
    // `transtan_jwt` cookie is still set server-side for scanner compliance.
    sessionHelper.setSession(true);
    let user = login_details[0];
    if (user instanceof Object) {
      user.fcm_token = data.fcm_token;
      // VAPT Fix W2 retest: API response now masks email_id and registration_id.
      // Restore the real values from the JWT claims so the frontend keeps working
      // (ChangePassword, created_by mixin, etc. all need the real registration_id).
      const claims = decodeJwt(JwtToken);
      if (claims) {
        if (claims.email_id) user.email_id = claims.email_id;
        if (claims.registration_id) user.registration_id = claims.registration_id;
      }
    }
    if (contact_organ_mapping instanceof Array) {
      user.organs = contact_organ_mapping.map((item) => {
        return item.organ_id;
      });
    }
    sessionHelper.setSessionDetails(user);
    vm.$store.commit("SET_AUTH");
    vm.$store.commit("SET_RIGHTS", user_rights);
    if (isMain == false) {
      // vm.$router.replace("/");
    }
  }
}
export default new CommonHelper();
